import { render, staticRenderFns } from "./BlockInterface.vue?vue&type=template&id=5842176b&"
import script from "./BlockInterface.vue?vue&type=script&lang=js&"
export * from "./BlockInterface.vue?vue&type=script&lang=js&"
import style0 from "./BlockInterface.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports